import {
  Action,
  ActionStatus,
  ActionType,
  CenterDeliveries,
  JourneyCollection,
} from 'interfaces/journey';

export const isCollectionDelivery = (action: Action) =>
  !!action.collectionId && action.actionType === ActionType.Deliver;

export const buildCenterDeliveries = (
  deliveries: Action[],
  collectionsById: Record<number, JourneyCollection>,
  receivedIds: Set<number>,
  notCollectedIds: Set<number>,
): CenterDeliveries => {
  const pending = deliveries.filter(
    (action) =>
      action.status !== ActionStatus.Canceled &&
      action.status !== ActionStatus.Transferred &&
      !notCollectedIds.has(action.collectionId as number),
  );
  const isReceived = (action: Action) =>
    action.status === ActionStatus.Completed ||
    receivedIds.has(action.collectionId as number);
  return {
    total: pending.length,
    received: pending.filter(isReceived).length,
    carried: pending
      .filter(
        (action) =>
          collectionsById[action.collectionId as number]?.carriedFromJourneyId,
      )
      .map((action) => {
        const collection = collectionsById[action.collectionId as number];
        return {
          collectionId: collection.id,
          storeName: collection.storeName,
          fromJourneyId: collection.carriedFromJourneyId as string,
          received: isReceived(action),
        };
      }),
  };
};
